import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getAllCities, updateCityById } from "../actions/cityActions";
import { updateCategoriesById } from "../actions/categories";

const AdminGeneralEditModal = ({
  openEditModal,
  showEditModal,
  current,
  //   openEditCategoryModal,
  //   showEditCategoryModal,
  //   openEditSubCategoryModal,
  //   showEditSubCategoryModal,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const city = useSelector((state) => state.city);
  const [values, setValues] = useState({
    _id: "",
    name: "",
    longitude: "",
    latitude: "",
    status: "",
  });
  const handleChange = (fieldName) => (event) => {
    setValues({
      ...values,
      [fieldName]: event.target.value,
    });
  };

  const currentCate = async () => {
    try {
      setValues({
        id: "",
        name: "",
        longitude: "",
        latitude: "",
        status: "",
      });
      setValues({
        id: current.id,
        name: current.name,
        longitude: current.longitude,
        latitude: current.latitude,
        status: current.status,
      });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    currentCate();
  }, [current]);

  const cityData = {
    _id: values.id,
    name: values.name,
    longitude: values.longitude,
    latitude: values.latitude,
    status: values.status,
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    for (let key of Object.keys(cityData)) {
      if (cityData[key] === "") {
        delete cityData[key];
      }
    }
    dispatch(updateCityById(cityData));
    setTimeout(() => {
      dispatch(getAllCities());
    }, 1000);
    openEditModal();
  };
  return (
    <>
      {showEditModal && (
        <div
          className={`modal fade ${showEditModal === true ? "show" : "hide"}`}
          id="addnewModal"
          tabIndex="-1"
          aria-labelledby="addnewModalLabel"
          // aria-hidden="true"
          onClick={(e) => {
            // Check if the click occurred outside the modal content
            if (e.target === e.currentTarget) {
              openEditModal(); // Call your close modal function
            }
          }}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="addnewModalLabel">
                  Edit
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => openEditModal()}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  <fieldset>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="fName">City Name</label>
                          <input
                            type="text"
                            className="form-control"
                            id="fName"
                            placeholder="City Name"
                            value={values.name}
                            onChange={handleChange("name")}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="fName">Latitude</label>
                          <input
                            type="text"
                            className="form-control"
                            id="fName"
                            placeholder="Latitude"
                            value={values.latitude}
                            onChange={handleChange("latitude")}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="fName">Longitude</label>
                          <input
                            type="text"
                            className="form-control"
                            id="fName"
                            placeholder="Longitude"
                            value={values.longitude}
                            onChange={handleChange("longitude")}
                          />
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                      onClick={() => openEditModal()}
                    >
                      Close
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Save changes
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* {showEditCategoryModal && (
        <div
          className={`modal fade ${
            showEditCategoryModal === true ? "show" : "hide"
          }`}
          id="addnewModal"
          tabIndex="-1"
          aria-labelledby="addnewModalLabel"
          // aria-hidden="true"
          onClick={(e) => {
            // Check if the click occurred outside the modal content
            if (e.target === e.currentTarget) {
              openEditCategoryModal(); // Call your close modal function
            }
          }}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="addnewModalLabel">
                  Edit
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => openEditCategoryModal()}
                ></button>
              </div>
              <div className="modal-body">
                <form
                //   onSubmit={handleSubmit}
                >
                  <fieldset>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="text-center mb-3">
                          <label
                            className="avatar avatar-xxl profile-cover-avatar m-0 m-auto"
                            
                          >
                            <img
                              className="rounded border shadow-sm"
                              // src={defaultPic}
                              alt="picture"
                            />
                            <input
                              type="file"
                              id="avatar_upload"
                              className="d-none"
                              accept=".jpg, .jpeg, .png, .bmp"
                            />
                            <span className="avatar-edit">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-edit-2 avatar-uploader-icon shadow-soft"
                              >
                                <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                              </svg>
                            </span>
                          </label>
                          <p
                            className="fw-light text-info"
                            style={{ fontSize: "12px" }}
                          >
                            .jpg, .jpeg, .png, .bmp recommended size (512 X 512)
                            pixels
                          </p>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="fName">Category Name</label>
                          <input
                            type="text"
                            className="form-control"
                            id="fName"
                            placeholder="Category Name"
                          />
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                      onClick={() => openEditCategoryModal()}
                    >
                      Close
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Save changes
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )} */}
    </>
  );
};
export default AdminGeneralEditModal;
